import { Injectable, inject } from '@angular/core';
import * as _ from 'lodash';
import { toLower } from 'lodash';
import { LoggingService } from '../../shared/services/logging.service';

import { OMSContextSyncMessage } from '../models/oms-context-sync-message';
import { LanguageStore } from '../store';
import { AppStateService } from './app-state.service';
import { SignInService } from './sign-in.service';


@Injectable({
    providedIn: 'root'
})
export class OMSContextSyncService {
    private _appStateService = inject(AppStateService);
    private _languageStore = inject(LanguageStore);
    private _signInService = inject(SignInService);
    private _loggingService = inject(LoggingService);

    public runningInOMS = false;


    constructor() {

        this._addEventListener();

        this._signInService.userHasLoaded$.subscribe(loaded => {
            if (loaded) {
                this.init();
            }
        });
    }

    public init() {
        this._postMessage(new OMSContextSyncMessage({ type: 'omsMapReady' }));
        this._postMessage(new OMSContextSyncMessage({ type: 'requestGarages' }));
    }

    public refresh() {
        this._postMessage(new OMSContextSyncMessage({ type: 'requestGarages' }));
    }

    public updateTitle(title: string) {
        this._postMessage(new OMSContextSyncMessage({ type: 'updateTitle', body: title }));
    }

    private _postMessage(message: OMSContextSyncMessage) {
        window?.chrome?.webview?.postMessage(message);
    }

    private _addEventListener() {
        window?.chrome?.webview?.addEventListener('message', event => {
            this.runningInOMS = true;

            const message = new OMSContextSyncMessage(event.data);
            if (message.type === 'garages') {
                this._loggingService.logTrace(
                    'Updating garages from OMS no longer supported. Will be fetched from OMS.ID through api in the future');
            } else if (message.type === 'culture') {

                // exempelvis sv_se
                this._languageStore.setLanguage(toLower(message.body));
            } else {
                this._loggingService.logTrace(`Message of type ${message.type} could not be handled.`);
            }
        });
    }
}

declare global {
    interface Window {
        chrome: any;
    }
}
